import React from "react";
import Preloader from "../helper/Preloader";
import FooterOne from "../components/FooterOne";
import BottomFooter from "../components/BottomFooter";
import ScrollToTop from "react-scroll-to-top";
import HeaderOneCustomer from "../componentsAmazon/HeaderOneCustomer";
import WholesaleCenter from "../componentsAmazon/WholesaleCenter";

const WholesaleCenterAmazon = () => {
 
 
  return (
    <>
      {/* Preloader */}
      <Preloader />

      {/* ScrollToTop */}
      <ScrollToTop smooth color="#232F3F" />


      {/* HeaderOneCustomer */}
      <HeaderOneCustomer />
       {/* Conditionally Render WholesaleCenter */}
     
     
        <WholesaleCenter />
     

      {/* FooterOne */}
      <FooterOne />

      {/* BottomFooter */}
      <BottomFooter />
    </>
  );
};

export default WholesaleCenterAmazon;
